const types = {
  image: "image",
  video: "video",
};

export const Media = {
  initialValue: () => initialValue(),
  fromValues: (src, type) => fromValues(src, type),
  fromJSON: (data) => fromJSON(data),
  toMap: (data) => toMap(data),
  types: types,
};

const fromValues = (src, type) => ({
  src: src,
  type: type,
});

const initialValue = () => ({
  src: "",
  type: "",
});

const fromJSON = (data) => ({
  src: data?.file_url,
  type: types[data?.mime_type],
});

const toMap = (data) => ({
  file_url: data?.src,
  mime_type: data?.type,
});
